import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { CellContentRoot } from "../../../../../../LightTable";
import { StyledRow } from "../../../../../../common";

const getCarAlias = (data) => {
	const carShiftJournals = data?.executorShiftJournals?.length
		? data?.executorShiftJournals?.at(0)
		: null;

	const executorToCrews = data?.executorToCrews || [];

	const crew = carShiftJournals
		? executorToCrews.find(
				({ crew }) => crew?.car?.id === carShiftJournals?.car?.id,
		  )?.crew
		: data?.executorToCrews?.[0]?.crew;

	const car = crew ? crew?.car : data?.executorToCrews?.[0]?.crew?.car;

	return car?.callSign || "";
};

const CarCallSing = ({ active, data }) => {
	const name = useMemo(() => getCarAlias(data), [data]);

	return (
		<StyledRow
			colors={active ? "" : "lightgray"}
			justify="center"
			alignItems="center"
		>
			{name}
		</StyledRow>
	);
};

const CarCallSignsCellContent: React.FC<CarCallSignsCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => "TODO", []);

	return (
		<CellContentRoot
			alignItems="center"
			justify="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<CarCallSing
				active={item.active}
				// onDoubleClick={() => onRowDoubleClick(rowData)}
				data={item}
			/>
		</CellContentRoot>
	);
};

declare namespace CarCallSignsCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(CarCallSignsCellContent);
